import type { QueryKey } from '@tanstack/react-query';

import { queryClient } from '@/lib/react-query/queryClient';

/**
 * Factory for callback that invalidates query with passed query key.
 * Useful if you don't need to make any other action in event callback
 * @example
 * ```ts
 *   useMutation(
 *     ...
 *    {
 *       onSettled: inlidateQuery(['items'])
 *    }
 * )
 * ```
 */
export const invalidateQuery = (queryKey: QueryKey) => () => {
  return queryClient.invalidateQueries({ queryKey });
};
